import { addInhibitKeysListener } from "./addInhibitKeysListener";

export function addPrintOverlay(invokerFunction) {
    document.body.classList.add('bodyOverlay');
	addInhibitKeysListener();
	invokerFunction && invokerFunction();
}
